/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconverteroutput2Inputs */

const en_formatconverteroutput2 = /** @type {(inputs: Formatconverteroutput2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File type`)
};

const de_formatconverteroutput2 = /** @type {(inputs: Formatconverteroutput2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateityp`)
};

/**
* | output |
* | --- |
* | "File type" |
*
* @param {Formatconverteroutput2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconverteroutput2 = /** @type {((inputs?: Formatconverteroutput2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconverteroutput2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconverteroutput2(inputs)
	return de_formatconverteroutput2(inputs)
});
export { formatconverteroutput2 as "formatConverterOutput" }